<div class="dashboard__area section-pb-120" style="margin-top: 5%">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="dashboard__sidebar-wrap">
          <div class="dashboard__sidebar-title mb-20">
            <h6 class="title">Welcome, {{ Name }}</h6>
          </div>
          <nav class="dashboard__sidebar-menu">
            <ul class="list-wrap">
              <li [class.active]="formopen === 0">
                <a href="#" (click)="openComponent(0)">
                  <i class="fa fa-user"></i> My Profile
                </a>
              </li>
              <li
                [class.active]="formopen === 1"
                *appPortalFeature="'invoiceHistory'"
              >
                <a href="#" (click)="openComponent(1)">
                  <i class="fa fa-history"></i> Invoices History
                </a>
              </li>
              <li
                [class.active]="formopen === 2"
                *appPortalFeature="'changeRequests'"
              >
                <a href="#" (click)="openComponent(2)">
                  <i class="fa fa-file-alt"></i> Vendor Information Change
                  Request
                </a>
              </li>
              <li
                [class.active]="formopen === 3"
                *appPortalFeature="'purchaseHistory'"
              >
                <a href="#" (click)="openComponent(3)">
                  <i class="fa fa-receipt"></i> Purchase Order History
                </a>
              </li>
            </ul>
          </nav>
          <div class="dashboard__sidebar-title mt-30 mb-20">
            <h6 class="title">User</h6>
          </div>
          <nav class="dashboard__sidebar-menu">
            <ul class="list-wrap">
              <li>
                <a href="#" (click)="logout()">
                  <i class="fa fa-sign-out-alt"></i> Logout
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="dashboard__content-wrap dashboard__content-wrap-two">
          <div class="dashboard__content-title">
            <div *ngIf="formopen === 0">
              <h4 class="title">My Profile</h4>
            </div>
            <div *ngIf="formopen === 1">
              <h4 class="title">Invoice History</h4>
            </div>
            <div *ngIf="formopen === 2">
              <h4 class="title">Vendor Information Change Request Form</h4>
            </div>
            <div *ngIf="formopen === 3">
              <h4 class="title">Purchase order history</h4>
            </div>
          </div>

          <div class="row">
            <div *ngIf="formopen === 0">
              <div class="profile__content-wrap">
                <ul class="list-wrap">
                  <li><span>Vendor Name:</span> {{ Name || "NA" }}</li>
                  <li *ngIf="!isRestricted">
                    <span>Vendor ID:</span> {{ vendorNumber || "NA" }}
                  </li>
                  <li *ngIf="isRestricted">
                    <span>Vendor ID:</span> Available once your registration is
                    approved
                  </li>
                  <li><span>User Email:</span> {{ Email || "NA" }}</li>
                  <li><span>Address:</span> {{ Address || "NA" }}</li>
                  <li>
                    <span>Request Status:</span>
                    <span
                      [ngClass]="{
                        'status-in-progress':
                          Status === 'Your Request is In progress',
                        'status-completed':
                          Status === 'Your Request is Completed',
                        'status-denied': Status === 'Your Request was Denied',
                        'status-inactive':
                          Status === 'Your Request is Inactive',
                      }"
                      [style.color]="
                        Status === 'Your Request is In progress'
                          ? 'lightcoral'
                          : Status === 'Your Request is Completed'
                            ? 'green'
                            : Status === 'Your Request was Denied'
                              ? 'red'
                              : Status === 'Your Request is Inactive'
                                ? 'orange'
                                : 'inherit'
                      "
                    >
                      {{ Status }}
                    </span>
                  </li>
                  <li [hidden]="Status !== 'Your Request is Completed'">
                    <span>Request Completion Day:</span>{{ CompletionDate }}
                  </li>
                </ul>
              </div>
            </div>
            <div *ngIf="formopen === 1">
              <app-invoice-history></app-invoice-history>
            </div>
            <div *ngIf="formopen === 2">
              <app-information-change-request></app-information-change-request>
            </div>
            <div *ngIf="formopen === 3">
              <app-purchase-order-history></app-purchase-order-history>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
